import {Cell} from "@/src/components/project_conf/bidConfig_model";
import { renderToStaticMarkup } from 'react-dom/server';

export function copySheetDataToClipboard(data: Cell[][]) {
  copyToClipboard(data.map((row) => row.map((x) => x.value)));
}


export function copyToClipboard(data: any[]) {
  // Convert data (array of arrays) into a tab-delimited string
  const formattedData = data.map((row) => row.join('\t')).join('\n');

  // Copy the formatted data to the clipboard
  navigator.clipboard.writeText(formattedData).then(() => {
    console.log('Data copied to clipboard successfully!');
  }).catch(err => {
    console.error('Failed to copy data to clipboard:', err);
    throw new Error('Failed to copy')
  });
}

export async function pasteFromClipboard() {
  try {

    const text = await navigator.clipboard.readText();
    const data = text.split('\n').map(row => row.split('\t'));
    console.log(data);
    return data;
  } catch (err) {
    console.error('Failed to read clipboard data:', err);
  }
}



export function copyTableToClipboard(data: any[]) {
  
  const headers = Object.keys(data[0]).join('\t'); 
  const rows = data.map(row => {
    return Object.values(row).map(value => value || '').join('\t'); 
  }).join('\n');  

  const formattedData = `${headers}\n${rows}`;

  navigator.clipboard.writeText(formattedData).then(() => {
    console.log('Data copied to clipboard successfully!');
  }).catch((err) => {
    console.error('Failed to copy data:', err);
  });
}


// for compareBids
export function copyTableWihoutHeaderColumnToClipboard(data: any[]) {
  
  const rows = data.map(row => {
    return Object.values(row).map(value => value || '').join('\t'); 
  }).join('\n');  


  navigator.clipboard.writeText(rows).then(() => {
    console.log('Data copied to clipboard successfully!');
  }).catch((err) => {
    console.error('Failed to copy data:', err);
  });
}

